module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADnSURBVHgB7dfhDcIgEIbhwziAI3QFR3ASHcFN1MkcATboCJ/XpD8M0dgCkfuae5L7T8mbAiLOOefcCgDOOqNO1LkKm3nh7246B2GBz6aPGoQBvhspksJvtpPCMtFsUljOZlJYz1ZSKBNhJSmUs5EU6jVNKshK0wqkXtI5hRCSVNpJH4POs0tSaK8qqV4J5ZIUJtUrodwghUlZ+YBie7EhCXFCD51ji1/qIminycncK6EkxAfZf5PJoRz1ZS6C+Dp9B+mDhvpJGUH8qLeVTA5syeToksnNO82TTE4Xe5l3nCMZ55xzm/YCGtYn/k0E8MEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about us_process_icon_right.png
// module id = I+9N
// module chunks = 0